import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AlertContainer, Error } from '../../../../components';
import { Contract } from './components/ContractVoip';
var SelectPlanBDFForm = observer(function (props) {
    var checkAddressStore = props.checkAddressStore, planStore = props.planStore, setFieldValue = props.setFieldValue, errors = props.errors, values = props.values, touched = props.touched;
    React.useEffect(function () {
        window.setTimeout(processQueryString, 200);
    }, []);
    React.useEffect(function () {
        props.planStore.setDetailsFromForm(values);
        props.summaryStore.getSummary(values.contractCode, props.summaryStore.hardwareCode, props.checkAddressStore.nbnLocId, values.contractCode, null);
    }, [values.contractCode, values.existingNumber, values.numberToPort]);
    function processQueryString() {
        var plCode = (function (name, url) {
            if (url === void 0) { url = window.location.href; }
            var newName = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp("[?&]" + newName + "(=([^&#]*)|&|#|$)");
            var results = regex.exec(url);
            if (!results) {
                return null;
            }
            if (!results[2]) {
                return '';
            }
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        })('pl');
        if (plCode && !values.contractCode) {
            setFieldValue('contractCode', plCode);
            props.summaryStore.getSummary(plCode, '', props.checkAddressStore.nbnLocId, values.voipCode, props.saleStore.voucher ? props.saleStore.voucher.amount : null);
        }
    }
    function handleValueChange(e) {
        if (e.target.name === 'existingNumber') {
            setFieldValue('existingNumber', JSON.parse(e.target.value));
        }
        else {
            setFieldValue(e.target.name, e.target.value);
        }
    }
    function renderPlans() {
        var plans = planStore.getEligibleVoipPlans();
        return plans.map(function (p, i) { return (React.createElement("option", { key: p.code, id: i.toString(), value: p.code }, p.name)); });
    }
    return (React.createElement(Form, null,
        React.createElement(AlertContainer, null),
        planStore.voipPlans !== null && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-100" },
                React.createElement("label", { htmlFor: "contractCode", className: "w-100" },
                    "Select a plan:",
                    React.createElement(Field, { id: "contractCode", name: "contractCode", component: "select", className: "form-control select-inline shadow-alt " + (errors.contractCode &&
                            'error'), value: values.contractCode },
                        React.createElement("option", { value: "" }, "Please select a plan"),
                        renderPlans()),
                    React.createElement(Error, { name: "contractCode" }),
                    React.createElement("br", null))),
            values.contractCode && (React.createElement("div", { className: "w-100" },
                React.createElement(Contract, { plan: planStore.getVoipContract(values.contractCode) }))))),
        React.createElement("br", null),
        values.contractCode && (React.createElement("div", { className: "w-100" },
            React.createElement(ExistingNumber, { values: values, errors: errors, touched: touched, handleChange: handleValueChange }))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
var Waiver = function (_a) {
    var acceptWaiver = _a.acceptWaiver;
    return (React.createElement("div", { className: "waiver" },
        React.createElement("h4", null, "Customer service guarantee waiver"),
        React.createElement("p", null,
            React.createElement("small", null, "The Acurus voice service is supplied over the Voice Over Internet Protocol (VOIP). This differs from traditional voice services supplied over copper from other service companies, one of which is the low price.")),
        React.createElement("p", null,
            React.createElement("small", null, "Due to these differences, we require you to waive your rights under the Customer Service Guarantee (known as the \"CSG\").")),
        React.createElement("p", null,
            React.createElement("small", null, "The CSG obliges service providers to meet certain timeframes for service connection, fault rectification and the attendance of appointments. It also requires that written information about the CSG be provided to customers at least once every two years. Compensation is payable for failure to meet these performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "Agreeing to this waiver means that you will not be entitled to compensation if we fail to meet the CSG performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "You are under no obligation to agree to the waiver and you may withdraw your consent at any time within the 5-working day period from the time you received this email by contacting us. However, if you do not agree to the waiver we are unable to supply you with a voice service.")),
        React.createElement("p", null,
            React.createElement("small", null,
                "If you do not agree to this waiver, please email",
                ' ',
                React.createElement("a", { href: "mailto:servicedesk@acurus.com.au" }, "servicedesk@acurus.com.au"),
                ' ',
                "or call us on 1300 855 184 and mention that you do not wish to agree to this waiver and withdraw the application.")),
        React.createElement("label", { htmlFor: "voipCsgWaiverAccepted", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "voipCsgWaiverAccepted", name: "voipCsgWaiverAccepted", type: "checkbox", checked: acceptWaiver }),
            React.createElement("small", { className: "label label-waiver" }, "I agree to the above waiver, understand the consequences of consenting to the waiver; and hereby give my consent")),
        React.createElement(Error, { name: "voipCsgWaiverAccepted" })));
};
var ExistingNumber = function (_a) {
    var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "voip-label" }, "Would you like to keep your existing number?"),
        React.createElement("label", { htmlFor: "keepVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "keepVoipNumber", type: "radio", name: "existingNumber", value: "true", onChange: handleChange, checked: values.existingNumber === true }),
            React.createElement("small", { className: "label" }, "Yes, I would like to keep my existing number")),
        values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "numberToPort" }, "Existing phone number with area code"),
                React.createElement(Field, { id: "numberToPort", name: "numberToPort", component: "input", className: "form-control shadow-alt " + (errors.numberToPort &&
                        touched.numberToPort &&
                        'error'), onChange: handleChange, value: values.numberToPort }),
                React.createElement(Error, { name: "numberToPort" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "fullName" },
                    "Full name",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "fullName", name: "fullName", component: "input", className: "form-control shadow-alt " + (errors.fullName &&
                        touched.fullName &&
                        'error'), onChange: handleChange, value: values.fullName }),
                React.createElement(Error, { name: "fullName" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "address" },
                    "Address",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "address", name: "address", component: "input", className: "form-control shadow-alt " + (errors.address &&
                        touched.address &&
                        'error'), onChange: handleChange, value: values.address }),
                React.createElement(Error, { name: "address" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "accountNumber" }, "Account number with your current phone provider"),
                React.createElement(Field, { id: "accountNumber", name: "accountNumber", component: "input", className: "form-control shadow-alt " + (errors.accountNumber &&
                        touched.accountNumber &&
                        'error'), onChange: handleChange, value: values.accountNumber }),
                React.createElement(Error, { name: "accountNumber" })),
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted }))),
        React.createElement("label", { htmlFor: "newVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "newVoipNumber", type: "radio", name: "existingNumber", value: "false", onChange: handleChange, checked: values.existingNumber === false }),
            React.createElement("small", { className: "label" }, "No, I would like a new number")),
        React.createElement(Error, { name: "existingNumber" }),
        !values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted })))));
};
export var SelectPlanBDF = inject('checkAddressStore', 'appStore', 'summaryStore', 'saleStore', 'planStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.planStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var planStore = _a.planStore;
        return planStore.planDetails.formValues
            ? planStore.planDetails.formValues
            : planStore.planDetails.formInitialValues;
    },
    validate: function (values) {
        var errors = {};
        var hasSpaces = /^\s.*|.+\s$/;
        var isPhone = /^0(2|3|7|8)[0-9]{8}$/;
        function checkForSpaces(name) {
            if (hasSpaces.test(values[name])) {
                errors[name] = "Start/end of value must not contain spaces";
            }
        }
        if (values['contractCode']) {
            if (values.existingNumber) {
                if (values.numberToPort.match(isPhone) == null) {
                    errors.numberToPort = 'Please enter a valid Australian phone number';
                }
                if (!values.numberToPort) {
                    errors.numberToPort = 'Please enter your phone number';
                }
                else {
                    checkForSpaces('numberToPort');
                }
                if (!values.fullName) {
                    errors.fullName = 'Please enter your full name';
                }
                else {
                    checkForSpaces('fullName');
                }
                if (!values.address) {
                    errors.address = 'Please enter your address';
                }
                else {
                    checkForSpaces('address');
                }
                if (!/^[0-9]+$/.test(values.accountNumber)) {
                    errors.accountNumber = 'Please enter a valid account number';
                }
                if (!values.accountNumber) {
                    errors.accountNumber = 'Please enter your account number';
                }
                else {
                    checkForSpaces('accountNumber');
                }
            }
            if (!values.voipCsgWaiverAccepted) {
                errors.voipCsgWaiverAccepted = 'You must agree to the waiver';
            }
        }
        else {
            errors.contractCode = 'Please select a voip contract';
        }
        return errors;
    },
})(SelectPlanBDFForm));
//# sourceMappingURL=SelectPlanBDF.js.map